import { render } from "./AddCareer.vue?vue&type=template&id=749accc4"
import script from "./AddCareer.vue?vue&type=script&lang=js"
export * from "./AddCareer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__